import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {get} from 'lodash';
import classNames from 'classnames';

import {FILTER_1} from "../../../../../reducers/performance_reducers";
import {
    SetDashboardFiltersAction,
    CleanDashboardDataAction
} from "../../../../../actions/performance_actions";
import SelectionDataType from '../SelectionDataType';
import SkillGraph from '../SkillGraph';
import CategoryGraph from '../CategoryGraph';
import DomainGraph from '../DomainGraph';

export default function ({dataMode, setDataMode, dataType, setDataType}) {
    const dispatch = useDispatch();

    const renderData = () => {
        switch (dataType) {
            case 'claim':
                return (
                    <CategoryGraph
                    />
                );
            case 'domain':
                return (
                    <DomainGraph
                    />
                );
            case 'math':
            case 'ela':
            default:
                return (
                    <SkillGraph
                        dataType={dataType}
                    />
                );
        }
    }

    return (
        <div className="pam-component pam-selection-part pam-selection-right">
            <SelectionDataType
                dataMode={dataMode}
                dataType={dataType}
                setDataType={setDataType}
            />

            <div className="divider"></div>

            <div>
                {renderData()}
            </div>
        </div>
    );
}
